import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdAccordionComponent } from './cd-accordion/cd-accordion.component';
import { CdAccordionPanelComponent } from './cd-accordion-panel/cd-accordion-panel.component';
import { CdAccordionTplComponent } from './cd-accordion-tpl/cd-accordion-tpl.component';
import { CdAccordionPanelTplComponent } from './cd-accordion-panel-tpl/cd-accordion-panel-tpl.component';
import { TooltipIconModule } from 'src/app/shared/tooltip-icon/tooltip-icon.module';
import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsProgressModule } from '@cds/ng-web-components/progress';
import { NoResultFoundModule } from '../../shared/no-result-found/no-result-found.module';

@NgModule({
  imports: [
    CommonModule,
    CdsLanguageModule,
    CdsIconModule,
    TooltipIconModule,
    CdsProgressModule,
    NoResultFoundModule,
    CdAccordionComponent,
    CdAccordionPanelComponent,
    CdAccordionTplComponent,
    CdAccordionPanelTplComponent,
  ],
  exports: [CdAccordionComponent, CdAccordionPanelComponent, CdAccordionTplComponent, CdAccordionPanelTplComponent],
})
export class CdAccordionModule {}
